import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconUpload: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = "#5C656E",
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.05831 5.44169C6.81414 5.19752 6.81414 4.80166 7.05831 4.55749L9.55831 2.05749C9.61581 1.99999 9.68509 1.95417 9.76176 1.9225C9.91426 1.85917 10.0868 1.85917 10.2393 1.9225C10.3159 1.95417 10.385 1.99999 10.4425 2.05749L12.9425 4.55749C13.1867 4.80166 13.1867 5.19752 12.9425 5.44169C12.8208 5.56335 12.6608 5.62499 12.5008 5.62499C12.3408 5.62499 12.1808 5.56419 12.0591 5.44169L10.6258 4.00833V13.3333C10.6258 13.6783 10.3458 13.9583 10.0008 13.9583C9.65581 13.9583 9.37581 13.6783 9.37581 13.3333V4.00914L7.9425 5.4425C7.6975 5.68583 7.30248 5.68585 7.05831 5.44169ZM15 7.70833C14.655 7.70833 14.375 7.98833 14.375 8.33333C14.375 8.67833 14.655 8.95833 15 8.95833C16.3142 8.95833 16.875 9.51916 16.875 10.8333V15C16.875 16.3142 16.3142 16.875 15 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V10.8333C3.125 9.51916 3.68583 8.95833 5 8.95833C5.345 8.95833 5.625 8.67833 5.625 8.33333C5.625 7.98833 5.345 7.70833 5 7.70833C2.985 7.70833 1.875 8.81833 1.875 10.8333V15C1.875 17.015 2.985 18.125 5 18.125H15C17.015 18.125 18.125 17.015 18.125 15V10.8333C18.125 8.81833 17.015 7.70833 15 7.70833Z"
      fill={disabled ? "rgba(92, 101, 110, 1)": color}
    />
  </svg>
);

export default IconUpload;
